import { createSlice } from "@reduxjs/toolkit";

const chalanSlice = createSlice({
  name: "chalanSlice",
  initialState: {
    chalan: [],
    status: "ok",
  },
  reducers: {
    setChalanDetail: (state, action) => {
      state.chalan = action.payload;
    },
    editChalanDetail: (state, action) => {},
    validateChalanDetail: (state, action) => {
      return;
    },
  },
});

export const { setChalanDetail, editChalanDetail, validateChalanDetail } =
  chalanSlice.actions;
export default chalanSlice.reducer;
